<div class="phx-list-item-main">
  <span *ngIf="phxCondensed" tabindex="-1" class="phx-list-item-condensed">
    <ng-container *ngTemplateOutlet="defaultContent"></ng-container>
  </span>
  <span *ngIf="!phxCondensed" tabindex="-1" class="phx-list-item-container">
    
    <phx-checkbox *ngIf="selectionList?.multiple && checkboxPosition === 'before'" [phxIndeterminate]="indeterminate"
      [phxChecked]="selected" (click)="handleCheckClick($event)" 
      phx-list-pre></phx-checkbox>

    <ng-content select="[phx-list-avatar], [phx-list-icon], [phx-list-pre]"></ng-content>

    <span *ngIf="textItems.length" #phxListText class="phx-list-text">
      <ng-content select="phx-text-line, [phx-text-line]"></ng-content>
    </span>

    <ng-content select="[phx-post]"></ng-content>

    <ng-container *ngTemplateOutlet="defaultContent"></ng-container>

    <phx-checkbox *ngIf="selectionList?.multiple && checkboxPosition === 'after'" 
      [phxChecked]="selected" [tabIndex]="-1" phx-list-post></phx-checkbox>

  </span>
  
  <ng-template #defaultContent>
    <ng-content></ng-content>
  </ng-template>
  
  <ng-content select="[phx-list-action]"></ng-content>
</div>